import { render, staticRenderFns } from "./IndustryDistChart.vue?vue&type=template&id=a8ce471e&scoped=true"
import script from "./IndustryDistChart.vue?vue&type=script&lang=js"
export * from "./IndustryDistChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ce471e",
  null
  
)

export default component.exports